module.exports = __webpack_public_path__ + "static/img/operateDay.7289e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateDay.png
// module id = mnBF
// module chunks = 1